<template>
	<leaflet-map-selection :map="map" :leaflet="leaflet"
						   :geoJsonGeometry="geoJsonGeometry"></leaflet-map-selection>
</template>
<script>
	import LeafletMapSelection from "./LeafletMapSelection";
	export default {
		props: {
			map: {
				type: Object,
				required: true
			},
			leaflet: {
				type: Object,
				required: true
			},
			geoJsonGeometry: {
				type: String
			}
		},
		components: {
			LeafletMapSelection
		},
		methods: {
			fitBound(value) {
				if (value) {
					const selection = this.leaflet.geoJSON(JSON.parse(value));
					this.map.fitBounds(selection.getBounds());					
				}
			}
		},		
		watch: {
			geoJsonGeometry: {
				handler: 'fitBound',
				immediate: true
			}
		}
		//render() {
		//	return this.$slots.default;
		//}
	}
	
</script>
